<template>
    <div id="vy_main" style="overflow-x:hidden">
      <main>
  <template v-if="show_ok == 1">

        <!--ヘッダー-->
        <HeaderArea />

        <div id="main_area">

          <div style="
            width: 100%;
            display: flex;
            flex-direction: row;
            justify-content: center;">
            <div style="height:500px;display:flex;">
              <img src="../../images/top.jpg" alt="ボラ活エール" style="height:100%"/>
              <img src="../../images/top.jpg" alt="ボラ活エール" style="height:100%"/>
              <img src="../../images/top.jpg" alt="ボラ活エール" style="height:100%"/>
            </div>


            </div>
        </div>
        <!--フッター-->
        <FooterArea />
      </template>
      </main>
    </div>
    
        
    <!--メッセージを表示するモーダルウィンドウ-->
    <component v-bind:is="contentMessage"
                v-bind:message_text="message"
                v-bind:message_cat="message_cat"
                v-bind:message_flag="message_flag"
                v-on:call="call"
                v-on:close_message="Close_message"
                v-on:ok_message="OK_message"/>
</template>
  
    
<script setup>
  /* eslint-disable */
  import HeaderArea from './HomeHeader.vue'
  import FooterArea from './HomeFooter.vue'

  import MessageModal from '../common/MessageModal.vue'  
  import { useRouter } from 'vue-router'
  import { login_check } from '../js/userdata.js';
    
  const router = useRouter();
  /* 表示する子コンポーネント関係の情報 */
  
let message = ref("")//表示するメッセージ
let message_cat = ref(0)// メッセージのカテゴリ（0：OKのみ、1：OK or キャンセルの選択式）
let message_method = ref("")// こちら（親コンポーネント）に帰った時、どの処理（関数）を行うのか（message_catが1の時のみ）
let message_flag = ref(false)//表示・非表示フラグ

  const contentMessage = ref('')// 表示する子コンポーネントの情報（メッセージ表示エリア）
  contentMessage.value = null // 表示する子コンポーネント
  import { shallowRef, watch, ref } from 'vue'
  const content = shallowRef('')

  let param = {}
  let title = "ボラ活エール"

  let show_ok = ref(0)

    // 戻り先がストレージに保存されている場合
    if(localStorage.getItem('return_shakyo') != null
        && localStorage.getItem('return_shakyo') != undefined){
          
        let return_city = localStorage.getItem('return_shakyo')
        
        //alert(JSON.stringify(paramMap));
        //alert(paramMap["error_description"])
        setTimeout(function(){
            // LINEログインでエラーが発生した場合はURLが変なのでエラーメッセージ出力
            if(location.search != ""){
              
                const queryString = window.location.search; // URLから値を取得
                const queryStringWithoutQuestionMark = queryString.substring(1);
                const params = queryStringWithoutQuestionMark.split('&');
                const paramMap = {};
                // URLから取得した値を配列に直す
                for (const param of params) {
                    const [key, value] = param.split('=');
                    paramMap[key] = value;
                }
                let set_provider = localStorage.getItem('set_provider')
                if(set_provider == "LINE" && paramMap["error_description"]){
                    message.value = "LINEにメールアドレスが設定されていなかったため、アカウントが作成できませんでした。\nメールアドレスを設定してから、再度新規登録を行ってください。\n\n※設定の仕方が分からない場合は、<a href='https://guide.line.me/ja/account-and-settings/account-and-profile/set-email-address.html' target='_blank'>こちら</a>をご覧ください。";
                    message_cat.value = 0;
                    message_flag.value = true;
                    message_method.value = "line_login_error";
                    contentMessage.value = MessageModal
                }else{
                  
                  setTimeout(function(){
                    location.href = location.protocol+"//"+location.host+"/"+return_city+"/Taiken"
                  },"1500")
                  
                }
            }else{

              setTimeout(function(){
                    location.href = location.protocol+"//"+location.host+"/"+return_city+"/Taiken"
              },"1500")
              
            }
        },"1500")

    }else{
        show_ok.value = 1
    }
        
        
    // メッセージを表示するウィンドウでOKを押された時
    let OK_message = function(){ 

        message_flag.value = false;
        contentMessage.value = null
        
        let return_city = localStorage.getItem('return_shakyo')

        setTimeout(function(){
          location.href = location.protocol+"//"+location.host+"/"+return_city+"/Taiken"
        },"1500")
        localStorage.removeItem('return_shakyo') 
    }
 </script>
  
<style scoped>

  #main_area{
    width:100%;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  #main_area_link{
    font-size: 17px;
    display: flex;
    justify-content: space-evenly;
    width: 50%;
    height: 200px;
    align-items: center;
  }
  #main_area_link a,
  #main_area_link a:hover{
    color:black;
    text-decoration-line:underline
  }

</style>
  